<template>
	<div class="LogosGrid" :class="classes">
		<div class="LogosGrid-heading">
			<CloHeading size="5" :level="headingLevel.toString()" minor subheading>
				{{ heading }}
			</CloHeading>
		</div>
		<div class="LogosGrid-group">
			<!-- Slot for Grid Items-->
			<slot />
		</div>
	</div>
</template>

<script>
import CloLogosGridItem from '@/layouts/CloLogosGrid/CloLogosGridItem.vue';
import CloHeading from '@/base/CloHeading/CloHeading.vue';

export default {
	name: 'CloLogosGrid',
	components: { CloLogosGridItem, CloHeading },
	props: {
		/**
		 * Label for the logos
		 */
		heading: {
			type: String,
			required: true,
		},
		/**
		 * Heading level for appropriate contextual hierarchy
		 */
		headingLevel: {
			type: Number,
			required: true,
		},
		/**
		 * Sets logos to grayscale
		 */
		grayscale: {
			type: Boolean,
			default: false,
		},
		/**
		 * For use in sidebar, where logos will be stacked with less spacing
		 */
		narrow: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			let classes = [];
			const prefix = 'LogosGrid--';
			if (this.grayscale) {
				classes.push(prefix + 'grayscale');
			}
			if (this.narrow) {
				classes.push(prefix + 'narrow');
			}
			return classes.join(' ');
		},
	},
};
</script>

<style lang="scss">
.LogosGrid {
	width: 100%;
	background-color: $color-neutral-0;
	@include inset-md;
	.LogosGrid-group {
		display: flex; // ie11
		display: grid;
		gap: $space-sm;
		grid-template-columns: repeat(auto-fit, minmax(6rem, 1fr));
		@include breakpoint(medium) {
			grid-template-columns: repeat(auto-fit, minmax(8rem, 1fr));
		}
	}
	.LogosGrid-item {
		display: grid;
		place-items: center;
		background-color: $color-white;
		border-radius: $radius-sm;
		@include inset-md;
		min-height: 6rem;
		img,
		svg {
			max-width: 100%;
			max-height: 7rem;
		}
	}
	a:hover,
	a:focus {
		@include dropshadow-2;
	}
}

// grayscale until hover
.LogosGrid--grayscale {
	.LogosGrid-item {
		img,
		svg {
			filter: grayscale(1);
		}
	}
	a:hover,
	a:focus,
	span:hover,
	span:focus {
		img,
		svg {
			filter: grayscale(0);
		}
	}
}

// for use in a narrow sidebar
.LogosGrid--narrow {
	.Heading {
		@include text(2);
	}
	.LogosGrid-group {
		// using flex here so grid doesn't overflow a narrow container
		display: flex;
	}
	.LogosGrid-item {
		@include inset-sm;
		width: 100%;
	}
}
</style>
